import React from "react";
import { CartesianGrid, Line, LineChart, ReferenceArea, ResponsiveContainer, Tooltip, XAxis, YAxis, } from "recharts";
import { useTheme } from "styled-components";
import { ZChartTooltip, zIndex } from "../../styled_components";
import { Box } from "../Box";
import { ChartToolTip } from "./ChartToolTip";
import { EmptyChart } from "./EmptyChart";
export const MultiLineChart = (props) => {
    const theme = useTheme();
    const { colors: { chartColors }, } = theme;
    const { backgroundColor = chartColors.defaultBackgroundColor, colors = [], connectNulls = false, customizedDot, data, dot = false, emptyMessage, enableXAxis = false, enableYAxis = false, height, hideLines = [], labelFormatter, testProps = {
        responsiveContainerHeight: "100%",
        responsiveContainerWidth: "100%",
    }, referenceArea, showXCartesianGrid = false, tooltip = false, tooltipUnits, width, xAxisProps = {
        domain: ["dataMin", "dataMax"],
        scale: "auto",
        type: "category",
    }, yAxisProps = {
        type: "number",
    }, } = props;
    if (data.length === 0) {
        return (React.createElement(Box, { "data-testid": "MultiLineChart", style: { backgroundColor, height, width: "100%" } },
            React.createElement(EmptyChart, { emptyMessage: emptyMessage })));
    }
    const lines = Object.keys(data[0].values);
    const chartValues = data.map(({ name, values }) => (Object.assign(Object.assign({}, values), { name })));
    return (React.createElement(Box, { "data-testid": "MultiLineChart", style: { backgroundColor, height, width: "100%" } },
        React.createElement(ResponsiveContainer, { height: testProps.responsiveContainerHeight, width: testProps.responsiveContainerWidth },
            React.createElement(LineChart, { width: width, height: height, data: chartValues, margin: {
                    bottom: theme.space[2],
                    left: theme.space[3],
                    right: theme.space[3],
                    top: theme.space[2],
                } },
                referenceArea && (
                // @ts-expect-error typing in recharts needs to be fixed
                React.createElement(ReferenceArea, Object.assign({ fill: chartColors.defaultReferenceArea, fillOpacity: 1 }, referenceArea))),
                tooltip && (React.createElement(Tooltip, { wrapperStyle: { zIndex: zIndex(ZChartTooltip) }, content: React.createElement(ChartToolTip, { colors: colors, defaultColor: chartColors.defaultColor, indentedLabels: hideLines, units: tooltipUnits, labelFormatter: labelFormatter }) })),
                showXCartesianGrid && React.createElement(CartesianGrid, { vertical: false, stroke: chartColors.stroke }),
                enableYAxis && (React.createElement(YAxis, Object.assign({ axisLine: { stroke: chartColors.stroke }, tick: { fill: chartColors.axisLabels }, tickLine: false }, yAxisProps))),
                enableXAxis && (React.createElement(XAxis, Object.assign({ dataKey: "name", axisLine: { stroke: chartColors.stroke }, tick: { fill: chartColors.axisLabels }, tickLine: false }, xAxisProps))),
                lines.map((line, idx) => (React.createElement(Line, { dataKey: line, display: hideLines.indexOf(line) >= 0 ? "none" : "", key: `${line}_${idx}`, name: line, stroke: colors[idx] || chartColors.defaultColor, strokeWidth: 2, dot: dot ? customizedDot || { fill: colors[idx] || chartColors.defaultColor, r: 2, strokeWidth: 2 } : false, connectNulls: connectNulls })))))));
};
